/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ImmutableDenseMatrixDependencies } from './dependenciesImmutableDenseMatrixClass.generated.js';
import { createIndexClass } from '../../factoriesAny.js';
export var IndexDependencies = {
  ImmutableDenseMatrixDependencies,
  createIndexClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIndexClass.generated.js
// module id = 53
// module chunks = 2